// extracted by mini-css-extract-plugin
export default {"dropzone":"ok8OwG3d_Mu04DT","dragging":"IXMSIDN4aU92gcu","dropzone-overlay":"idvsCXuuDlbGyXX","dropzone-icon":"wYkcXsQK6DNIryg","dropzone-text":"DT8nTCb9Ej6Crbw"};